import { HEADER_CONTACT_CLOSE, HEADER_CONTACT_OPEN } from './actions';
import { createReducer } from 'store/createReducer';
import { DropdownContactModel } from 'models/DropdownContactModel';

export const initialState: DropdownContactModel = {
  isOpen: false,
  phoneNumberCompact: '',
  shortOpeningInfo: '',
  openingInfo: '',
  extraInfo: '',
  openingBody: '',
  phonenumber: '',
  greeting: '',
  contactUrl: '',
  contactCaption: '',
  openingInfoCustomerService: '',
  isCritical: false
};

export default createReducer(initialState, {
  [HEADER_CONTACT_OPEN]: state => {
    return { ...state, isOpen: true };
  },
  [HEADER_CONTACT_CLOSE]: state => {
    return { ...state, isOpen: false };
  }
});
